import { render, staticRenderFns } from "./paperDetail.vue?vue&type=template&id=64552286&scoped=true"
import script from "./paperDetail.vue?vue&type=script&lang=js"
export * from "./paperDetail.vue?vue&type=script&lang=js"
import style0 from "./paperDetail.vue?vue&type=style&index=0&id=64552286&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64552286",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64552286')) {
      api.createRecord('64552286', component.options)
    } else {
      api.reload('64552286', component.options)
    }
    module.hot.accept("./paperDetail.vue?vue&type=template&id=64552286&scoped=true", function () {
      api.rerender('64552286', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/details/paperDetail.vue"
export default component.exports